export enum MetricsTabs {
    REALTIME = 'realtime',
    CONVERSATIONS = 'conversations',
    ENDING = 'ending',
    SALES = 'sales'
}
